"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpringboardContextProvider = exports.useSpringboardContext = exports.makeSpringboardAppUrl = exports.makeIdentityPlatformUrl = exports.SpringboardAppOrigin = exports.AuthenticationOrigin = void 0;
var React = __importStar(require("react"));
var AuthenticationContext_1 = require("./AuthenticationContext");
var SpringboardApi_1 = require("./SpringboardApi");
var SpringboardContext = React.createContext(undefined);
var AuthenticationOrigin;
(function (AuthenticationOrigin) {
    AuthenticationOrigin["SavePage"] = "save page";
    AuthenticationOrigin["ContactOwner"] = "contact owner";
    AuthenticationOrigin["SpringboardEngagementMenu"] = "springboard engagement menu";
    AuthenticationOrigin["AcceptPrefill"] = "accept prefill";
    AuthenticationOrigin["DocumentSavedNotification"] = "document saved notification";
})(AuthenticationOrigin || (exports.AuthenticationOrigin = AuthenticationOrigin = {}));
var SpringboardAppOrigin;
(function (SpringboardAppOrigin) {
    SpringboardAppOrigin["GoToSavedPages"] = "saved page button";
    SpringboardAppOrigin["SavedPageNotification"] = "saved page notification";
    SpringboardAppOrigin["SpringboardEngagementMenu"] = "springboard engagement menu";
    SpringboardAppOrigin["DocumentSavedNotification"] = "document saved notification";
    SpringboardAppOrigin["PostAcceptSignedInNotification"] = "post-accept signed in notification";
})(SpringboardAppOrigin || (exports.SpringboardAppOrigin = SpringboardAppOrigin = {}));
var addQueryParams = function (params) {
    if (Object.keys(params).length > 0) {
        var paramString = Object.entries(params)
            .map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return (value !== undefined ? "".concat(key, "=").concat(encodeURIComponent(value)) : "");
        })
            .filter(function (param) { return !!param; })
            .join("&");
        return "?".concat(paramString);
    }
    return "";
};
var makeIdentityPlatformUrl = function (baseUrl) {
    return function (path, origin, continueUrl) {
        var authRoutePrefix = "auth/v1/";
        return "".concat(baseUrl, "/").concat(path !== "user/profile" ? authRoutePrefix : "").concat(path).concat(addQueryParams({
            continueUrl: continueUrl === null || continueUrl === void 0 ? void 0 : continueUrl.toString(),
            origin: origin,
        }));
    };
};
exports.makeIdentityPlatformUrl = makeIdentityPlatformUrl;
var makeSpringboardAppUrl = function (baseUrl) {
    return function (path, origin) {
        return "".concat(baseUrl, "/").concat(path).concat(addQueryParams({ origin: origin }));
    };
};
exports.makeSpringboardAppUrl = makeSpringboardAppUrl;
var useSpringboardContext = function () {
    var ctx = React.useContext(SpringboardContext);
    if (!ctx) {
        throw new Error("useSpringboardContext() must be used within a <SpringboardContextProvider> component");
    }
    return ctx;
};
exports.useSpringboardContext = useSpringboardContext;
var SpringboardContextProvider = function (_a) {
    var children = _a.children, authAppBaseUrl = _a.authAppBaseUrl, springboardAppBaseUrl = _a.springboardAppBaseUrl, consumerDataServiceUrl = _a.consumerDataServiceUrl, pageHash = _a.pageHash, pageOwnerEmail = _a.pageOwnerEmail;
    var getToken = (0, AuthenticationContext_1.useAuthenticationContext)().getToken;
    var _b = __read(React.useState(""), 2), pageUrl = _b[0], setPageUrl = _b[1];
    React.useEffect(function () {
        var url = new URL(window.location.href);
        setPageUrl(url.toString());
    }, []);
    var savePage = function () { return (0, SpringboardApi_1.setSavedPage)(consumerDataServiceUrl, pageHash, getToken); };
    var deletePage = function () { return (0, SpringboardApi_1.deleteSavedPage)(consumerDataServiceUrl, pageHash, getToken); };
    var fetchPageStatus = function () { return (0, SpringboardApi_1.fetchPageSavedState)(consumerDataServiceUrl, pageHash, getToken); };
    return (React.createElement(SpringboardContext.Provider, { value: {
            getAuthenticationUrl: (0, exports.makeIdentityPlatformUrl)(authAppBaseUrl),
            getSpringboardUrl: (0, exports.makeSpringboardAppUrl)(springboardAppBaseUrl),
            pageOwnerEmail: pageOwnerEmail,
            pageUrl: pageUrl,
            savePage: savePage,
            fetchPageStatus: fetchPageStatus,
            deletePage: deletePage,
        } }, children));
};
exports.SpringboardContextProvider = SpringboardContextProvider;
